export const smallScreenBound = 600;
export const SAVE_SUCCESS = 'SAVE_SUCCESS';